var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82634 11.5634L5.23544 6.56343C5.46713 6.22361 5.46713 5.77658 5.23544 5.43676L1.82634 0.43676C1.51522 -0.0195528 0.893092 -0.137253 0.43678 0.17387C-0.0195341 0.484992 -0.137233 1.10712 0.17389 1.56343L3.15 6L0.17389 10.4368C-0.137233 10.8931 -0.0195341 11.5152 0.43678 11.8263C0.893092 12.1374 1.51522 12.0197 1.82634 11.5634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.9782471d23bae6bc57961b1d34c8e167.svg";
export { ForwardRef as ReactComponent };